module.exports = __webpack_public_path__ + "img/creative-portfolio.ca658925.png";